<template>
    <div class="settingPage">
        <router-view></router-view>
        <div class="settings__top"></div>

        <div class="settingsHolder">
            <div class="settingsButton" @click="openUser">Personalien</div>
            <div class="settingsButton" @click="openTrain">Züge</div>
            <div class="settingsButton" @click="openAnb">Allgemeine Nutzungsbedingungen</div>

        </div>
    </div>
</template>

<script>

export default {
    data() {
        return {
        }
    },
    computed: {

    },
    methods: {
        openUser() {
            this.$router.push({ name: 'usersettings' })
        },
        openTrain() {
            this.$router.push({ name: 'favtrains' })
        },
        openAnb() {
            this.$router.push({ name: 'anb' })
        }
    },
    created() {

    }
}
</script>

<style scoped lang="scss">

.settingPage{
    position: absolute;
    width: 100%;
    height: 100vh;
    /*overflow-y: scroll;*/
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.settingsHolder{
    display: flex;
    flex-direction: column;
    width: 100%;
    /*height: 100vh;*/
    /* overflow-y: scroll; */
}

.settingsButton{
    width: 100%;
    font-size: 2rem;
    text-align: center;
    /*height: 3rem;*/
    cursor: pointer;
    padding: 0.625rem;
}
.settingsButton:hover{
    background-color: $color-gray;
}

.settingsButton:active{
    background-color: $color-green;
}

.settings__top{
    height: 70px;
}

@include medium{

    .train-settings__top{
        display: none;
    }
    .settingsHolder{
        width: 31rem;
        @include default-shadow;
    }
}

@include extra-large{

    .settingsHolder{
        width: 31rem;
        @include default-shadow;
        /*height: 80vh;*/
    }
}

</style>
